import { SecondFeatureSegmentationConfig, SelectedCustomFeatureContext } from '../../common/selection.menu/types';
import { Entity, GroupedEntity } from './common.types';
import { Filters } from './filter.types';

export enum SettingSelector {
  singleSelect = 'singleSelect',
  radioGroup = 'radioGroup',
  multiSelect = 'multiSelect',
  custom = 'custom',
}

export type ContextTrackingMetadata = {
  hasPageView?: boolean;
};

export type SettingDefinition = {
  name: string;
  labels?: {
    identifier: string;
    label: string;
    prefix?: string;
    suffix?: string;
  };
  selection: {
    isSelectable: boolean;
    selector?: SettingSelector;
    options?: (Entity | GroupedEntity | string)[];
    optionsUrl?: string;
    isSecondary?: boolean;
    metadata?: { tracking?: ContextTrackingMetadata };
  };
  isParam: boolean;
  metadata?: { tracking: { propertyName: string; includePropertyValue?: boolean } };
};

export type SettingsValues = Record<string, Entity[]>;

export type ContextSettings = {
  definitions: SettingDefinition[];
  values: SettingsValues;
};

export type CustomFeature = {
  [pageName: string]: {
    [originMenu: string]: CustomFeatureDetails;
  };
};

export type CustomFeatureDetails = {
  selectedFeature?: SelectedCustomFeatureContext;
  originMenu?: string;
  customFeatureType?: string;
  secondSegmentationConfig?: SecondFeatureSegmentationConfig;
};

export type CustomFeatureContext = { customFeature?: CustomFeature };

export type Context = {
  settings: ContextSettings;
  filters?: Filters;
} & CustomFeatureContext;
